
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/videos/categories/[...slugs]",
      function () {
        return require("private-next-pages/videos/categories/[...slugs].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/videos/categories/[...slugs]"])
      });
    }
  